import React from 'react';
import styled from '@emotion/styled';
import breakpoints from './Theme/breakpoints';

const BiographyWrapper = styled.div`
  margin-top: 8px;
`;

const BiographyBody = styled.div`
  @media (min-width: ${breakpoints.lg}px) {
    width: calc(100% - 232px);
  }
  p {
    margin: 0;
  }
  line-height: ${
  (properties) => properties.theme.typography?.body1?.lineHeight
};
  font-size: ${
  (properties) => properties.theme.typography?.body1?.fontSize
};
  font-family: ${
  (properties) => properties.theme.typography?.body1?.fontFamily
};
  color: ${
  (properties) => properties.theme.palette?.text?.secondary
};
`;

interface AuthorBiographyProperties {
  bio: string;
}

const AuthorBiography = ({
  bio,
}: AuthorBiographyProperties) => (
  <BiographyWrapper>
    <BiographyBody dangerouslySetInnerHTML={{ __html: bio }} />
  </BiographyWrapper>
);

export default AuthorBiography;
